import { StyleSheet, Image, View } from 'react-native';
import { useEffect, useState } from 'react';

const DEFAULT_ASPECT_RATIO = 3 / 2;

export default function ImageViewer2({ placeholderImageSource, selectedImage }) {
  const [aspectRatio, setAspectRatio] = useState(DEFAULT_ASPECT_RATIO);

  // measure the real image so the container matches its shape instead of cropping it to a fixed box
  useEffect(() => {
    let isCancelled = false;

    if (selectedImage) {
      Image.getSize(
        selectedImage,
        (width, height) => {
          if (!isCancelled && width && height) {
            setAspectRatio(width / height);
          }
        },
        () => {
          if (!isCancelled) {
            setAspectRatio(DEFAULT_ASPECT_RATIO);
          }
        }
      );
    } else if (typeof Image.resolveAssetSource === 'function') {
      const resolved = Image.resolveAssetSource(placeholderImageSource);
      setAspectRatio(resolved && resolved.width && resolved.height ? resolved.width / resolved.height : DEFAULT_ASPECT_RATIO);
    } else {
      // react-native-web has no resolveAssetSource; require() resolves to a plain URL string there instead
      const placeholderUri = typeof placeholderImageSource === 'string' ? placeholderImageSource : placeholderImageSource?.uri;
      if (placeholderUri) {
        Image.getSize(
          placeholderUri,
          (width, height) => {
            if (!isCancelled && width && height) {
              setAspectRatio(width / height);
            }
          },
          () => {
            if (!isCancelled) {
              setAspectRatio(DEFAULT_ASPECT_RATIO);
            }
          }
        );
      } else {
        setAspectRatio(DEFAULT_ASPECT_RATIO);
      }
    }

    return () => {
      isCancelled = true;
    };
  }, [selectedImage, placeholderImageSource]);

  const imageSource = selectedImage !== null
    ? { uri: selectedImage }
    : placeholderImageSource;

  return (
    <View style={[styles.container, { aspectRatio }]}>
      <Image 
        source={imageSource} 
        style={styles.image} 
        resizeMode="contain" 
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius: 8,
  },
});
